// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("./common/http.res.js");
var Image$ReactHooksTemplate = require("./common/image.res.js");
var Loading$ReactHooksTemplate = require("./dashboard/dashboard/Loading.res.js");
var Campaign$ReactHooksTemplate = require("./surveys/campaign.res.js");
var Download$ReactHooksTemplate = require("./download.res.js");
var Pagination$ReactHooksTemplate = require("./common/Pagination.res.js");
var SearchForm$ReactHooksTemplate = require("./surveys/SearchForm.res.js");
var AuthProvider$ReactHooksTemplate = require("./AuthProvider.res.js");
var PaginationUtils$ReactHooksTemplate = require("./common/PaginationUtils.res.js");

function totalRecord(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function perPage(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

var emptyPageInfo = {
  total: "1",
  per_page: "1"
};

var searchPlaceholder = "Search Downloads";

function Downloads(props) {
  var match = React.useState(function (param) {
        return /* [] */0;
      });
  var setState = match[1];
  var match$1 = React.useState(function (param) {
        return emptyPageInfo;
      });
  var setPageInfo = match$1[1];
  var pageInfo = match$1[0];
  var match$2 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var match$3 = React.useState(function (param) {
        
      });
  var setSearchKey = match$3[1];
  var searchKey = match$3[0];
  var queryParams = Querystringify.parse(props.search);
  var x = Js_dict.get(queryParams, "page");
  var currentPage;
  if (x !== undefined && x !== "") {
    var page = Belt_Int.fromString(x);
    currentPage = page !== undefined ? page : 1;
  } else {
    currentPage = 1;
  }
  var x$1 = Js_dict.get(queryParams, "search");
  var currentSearchKey = x$1 !== undefined && x$1 !== "" ? x$1 : undefined;
  var handleSearch = function (param) {
    if (searchKey !== undefined) {
      return RescriptReactRouter.push("/campaigns/all?search=" + searchKey);
    } else {
      return RescriptReactRouter.push("/campaigns/all?");
    }
  };
  var handlePageChange = function (pageNumber) {
    var pageNumber$1 = String(pageNumber);
    if (currentSearchKey !== undefined) {
      return RescriptReactRouter.push("/campaigns/all?page=" + pageNumber$1 + "&search=" + currentSearchKey);
    } else {
      return RescriptReactRouter.push("/campaigns/all?page=" + pageNumber$1);
    }
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (downloads) {
                  return Promise.resolve(Curry._1(setState, (function (param) {
                                    return downloads;
                                  })));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/downloads", (function (param) {
                      return Json_decode.field("downloads", (function (param) {
                                    return Json_decode.list(Download$ReactHooksTemplate.decode, param);
                                  }), param);
                    })));
        }), []);
  React.useEffect((function (param) {
          var pageNumber = String(currentPage);
          var url = currentSearchKey !== undefined ? "/api/v1/downloads?page=" + pageNumber + "&search=" + currentSearchKey : "/api/v1/downloads?page=" + pageNumber;
          Js_promise.then_((function (param) {
                  var headers = param[0];
                  var x = headers.get("Total");
                  var total = x !== null ? (
                      x === null ? undefined : Caml_option.some(x)
                    ) : "1";
                  var x$1 = headers.get("Per-Page");
                  var per_page = x$1 !== null ? (
                      x$1 === null ? undefined : Caml_option.some(x$1)
                    ) : "1";
                  return Promise.resolve((Curry._1(setPageInfo, (function (param) {
                                      return {
                                              total: total,
                                              per_page: per_page
                                            };
                                    })), Curry._1(setSearchKey, (function (param) {
                                      return currentSearchKey;
                                    })), Js_promise.then_((function (json) {
                                      return Promise.resolve(Json_decode.field("campaigns", (function (param) {
                                                        return Json_decode.list(Campaign$ReactHooksTemplate.decode, param);
                                                      }), json));
                                    }), param[1])));
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url));
        }), [
        currentPage,
        currentSearchKey
      ]);
  var totalCount = Caml_format.int_of_string(pageInfo.total);
  var perPageCount = Caml_format.int_of_string(pageInfo.per_page);
  var totalPagesCount = PaginationUtils$ReactHooksTemplate.totalPages(totalCount, perPageCount);
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(Curry._1(match$2[0], "ShowReport") ? JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx("h2", {
                                        children: "Downloads",
                                        className: "text-xl font-semibold"
                                      }),
                                  className: "flex items-center border-b border-gray-300 px-30-px py-16-px justify-between"
                                }),
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx(SearchForm$ReactHooksTemplate.make, {
                                        searchKey: searchKey,
                                        setSearchKey: setSearchKey,
                                        handleSearch: handleSearch,
                                        searchPlaceholder: searchPlaceholder
                                      }),
                                  className: "flex justify-between px-30-px pt-20-px items-center"
                                }),
                            JsxRuntime.jsx(Pagination$ReactHooksTemplate.Bar.make, {
                                  currentPage: currentPage,
                                  totalPages: totalPagesCount,
                                  totalRecords: totalCount,
                                  perPage: perPageCount,
                                  handlePageChange: handlePageChange,
                                  itemLabel: "downloads",
                                  className: "mx-30-px mb-4"
                                }),
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("table", {
                                        children: [
                                          JsxRuntime.jsx("thead", {
                                                children: JsxRuntime.jsxs("tr", {
                                                      children: [
                                                        JsxRuntime.jsx("th", {
                                                              children: JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      "File",
                                                                      JsxRuntime.jsx("img", {
                                                                            className: "ml-4-px",
                                                                            src: Image$ReactHooksTemplate.heading
                                                                          })
                                                                    ],
                                                                    className: "flex"
                                                                  }),
                                                              className: "px-4 py-3"
                                                            }),
                                                        JsxRuntime.jsx("th", {
                                                              children: JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      "Status",
                                                                      JsxRuntime.jsx("img", {
                                                                            className: "ml-4-px",
                                                                            src: Image$ReactHooksTemplate.heading
                                                                          })
                                                                    ],
                                                                    className: "flex"
                                                                  }),
                                                              className: "px-4 py-3"
                                                            }),
                                                        JsxRuntime.jsx("th", {
                                                              children: JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      "Created At",
                                                                      JsxRuntime.jsx("img", {
                                                                            className: "ml-4-px",
                                                                            src: Image$ReactHooksTemplate.heading
                                                                          })
                                                                    ],
                                                                    className: "flex"
                                                                  }),
                                                              className: "px-4 py-3"
                                                            }),
                                                        JsxRuntime.jsx("th", {
                                                              children: JsxRuntime.jsx("div", {
                                                                    className: "flex"
                                                                  }),
                                                              className: "px-4 py-3"
                                                            })
                                                      ]
                                                    }),
                                                className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
                                              }),
                                          JsxRuntime.jsx("tbody", {
                                                children: $$Array.of_list(List.map((function (download) {
                                                            var rid = Download$ReactHooksTemplate.id(download);
                                                            var origin = window.location.origin;
                                                            var downloadUrl = origin + "/api/v1/downloads/" + String(rid) + "/download";
                                                            var match = Download$ReactHooksTemplate.status(download);
                                                            var tmp;
                                                            switch (match) {
                                                              case "Queued" :
                                                              case "InProgress" :
                                                                  tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
                                                                  break;
                                                              case "Completed" :
                                                                  tmp = JsxRuntime.jsx("a", {
                                                                        children: JsxRuntime.jsx("img", {
                                                                              className: "h-16-px",
                                                                              src: Image$ReactHooksTemplate.downloadButton
                                                                            }),
                                                                        href: downloadUrl
                                                                      });
                                                                  break;
                                                              
                                                            }
                                                            return JsxRuntime.jsxs("tr", {
                                                                        children: [
                                                                          JsxRuntime.jsx("td", {
                                                                                children: Download$ReactHooksTemplate.name(download),
                                                                                className: "px-4 py-3"
                                                                              }),
                                                                          JsxRuntime.jsx("td", {
                                                                                children: Download$ReactHooksTemplate.Status.toString(Download$ReactHooksTemplate.status(download)),
                                                                                className: "px-4 py-3"
                                                                              }),
                                                                          JsxRuntime.jsx("td", {
                                                                                children: Download$ReactHooksTemplate.createdAt(download).fromNow(false),
                                                                                className: "px-4 py-3"
                                                                              }),
                                                                          JsxRuntime.jsx("td", {
                                                                                children: tmp,
                                                                                className: "px-4 py-3"
                                                                              })
                                                                        ],
                                                                        className: "border-b border-bottom-gray-600"
                                                                      }, String(Download$ReactHooksTemplate.id(download)));
                                                          }), match[0]))
                                              })
                                        ],
                                        className: "text-left table-auto w-full border-separate text-xs font-medium"
                                      }),
                                  className: "flex px-30-px pb-30-px"
                                })
                          ]
                        }) : JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                                img: Caml_option.some(Image$ReactHooksTemplate.unAuthorized),
                                text: "401: Unauthorized!!",
                                loading: false
                              }),
                          className: "h-screen w-full animated fadeIn"
                        }))
            });
}

var emptyState = /* [] */0;

var make = Downloads;

exports.emptyState = emptyState;
exports.totalRecord = totalRecord;
exports.perPage = perPage;
exports.emptyPageInfo = emptyPageInfo;
exports.searchPlaceholder = searchPlaceholder;
exports.make = make;
/* react Not a pure module */
